const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/live/$roomSlug/public.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_minimal/live/$roomSlug/public")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});